import { faker } from '@faker-js/faker';
import { PatientCreditCard } from '@qmd-types/patient';

export default function getPatientCreditCardsFixture(): PatientCreditCard[] {
  return [
    {
      id: faker.string.uuid(),
      number: faker.string.octal({ length: 4, prefix: 'XXXX' }),
      type: 'discover',
      expiry: faker.date.anytime().toLocaleString(),
      isDefault: faker.datatype.boolean(),
    },
    {
      id: faker.string.uuid(),
      number: faker.string.octal({ length: 4, prefix: 'XXXX' }),
      type: 'americanexpress',
      expiry: faker.date.anytime().toLocaleString(),
      isDefault: faker.datatype.boolean(),
    },
    {
      id: faker.string.uuid(),
      number: faker.string.octal({ length: 4, prefix: 'XXXX' }),
      type: 'mastercard',
      expiry: faker.date.anytime().toLocaleString(),
      isDefault: faker.datatype.boolean(),
    },
    {
      id: faker.string.uuid(),
      number: faker.string.octal({ length: 4, prefix: 'XXXX' }),
      type: 'visa',
      expiry: '2024-10',
      isDefault: faker.datatype.boolean(),
    },
  ];
}
